import { gql } from "@apollo/client";
import {
  PaginatedListMetaNoNestingFragment,
  PaymentMethodNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { PaymentMethod as PaymentMethodEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import PaymentMethod from "../../data/model/PaymentMethod";
import { listOptions, listVariables } from "../constants";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { pageQuery } from "../page-query";

const paymentMethodsQuery = gql`
  ${PaymentMethodNoNestingFragment}
  ${PaginatedListMetaNoNestingFragment}
  query GetPaymentMethods(${listVariables}) {
    paymentMethods(${listOptions}) {
      items{
        ...PaymentMethodNoNesting
        handler {
          code
          args {
            name
            value
          }
        }
      }
      meta {
          ...PaginatedListMetaNoNesting
        }
    }
  }
`;

export const paymentMethodDefinition = new EntityResourceDefinition<
  PaymentMethodEntity,
  PaymentMethod
>({
  entity: "payment_methods",
  query: paymentMethodsQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.payType.id = fetchedEntity.payTypeId;
    newEntity.name = fetchedEntity.name || "";
    newEntity.enabled = fetchedEntity.enabled;
    newEntity.retailerPayCode = fetchedEntity.retailerPayCode || null;
    newEntity.retailerPayTypeId = fetchedEntity.retailerPayTypeId || null;
    newEntity.configuration = fetchedEntity.configuration || null;
    newEntity.handler = fetchedEntity.handler || null;
  },
  fetchEntities: (options) => {
    return pageQuery(client, "paymentMethods", paymentMethodsQuery, options);
  },
});
